import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import PropTypes from "prop-types"; // Import PropTypes

const AuthenticRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem("access_token"); 

  return isAuthenticated ? children || <Outlet /> : <Navigate to="/sign-in" />;
};

// Add prop validation for children
AuthenticRoute.propTypes = {
  children: PropTypes.node, // Validate that children can be any renderable node
};

export default AuthenticRoute;
